import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { useStacklineTheme } from '@stackline/ui';
import { GenericNavigationTabs } from 'src/components/BeaconV2Components/SubtabNav/SubtabNavigation';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'src/utils/Hooks';
import TopicsViewTab from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicsViewTab';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { shouldShowBeaconProTopics } from 'src/utils/app';
import { TopicsViewV2 } from './TopicsViewV2';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

enum TopicsTab {
  myTopics = 'myTopics',
  teamTopics = 'teamTopics'
}

interface TopicNavigationTabsProps {
  tab: TopicsTab;
  setTab: (tab: TopicsTab) => void;
}

/**
 * List of tabs for the top of the segments page
 */
const TopicNavigationTabs = ({ tab, setTab }: TopicNavigationTabsProps) => {
  return (
    <GenericNavigationTabs
      tab={tab}
      tabs={[
        {
          label: 'My Topics',
          onClick: () => setTab(TopicsTab.myTopics),
          value: TopicsTab.myTopics
        },
        {
          label: 'Team Topics',
          onClick: () => setTab(TopicsTab.teamTopics),
          value: TopicsTab.teamTopics
        }
      ]}
    />
  );
};

/**
 * Topics page container
 */
const Topics = () => {
  const theme = useStacklineTheme();
  const [tab, setTab] = useState(TopicsTab.myTopics);
  const { searchParams } = useAppSelector((state) => state.app.queryParams);

  if (shouldShowBeaconProTopics()) {
    return <TopicsViewV2 />;
  }

  return (
    <BasePageContainer sx={{ width: '100%', marginTop: '0px' }}>
      <Box display="flex" gap="44px" width="100%">
        <Box width="100%">
          <Box display="flex" justifyContent="space-between" width="100%">
            <Text variant="h2">Topics</Text>
            {[TopicsTab.myTopics, TopicsTab.teamTopics].includes(tab) && (
              <Link to={`/search${searchParams}&entityType=searchtermlist&action=create`}>
                <SlButton variant="contained">+ Create Topic</SlButton>
              </Link>
            )}
          </Box>
          <Box marginBottom={theme.spacing.lg}>
            <TopicNavigationTabs tab={tab} setTab={setTab} />
          </Box>
          <Box width="100%">{tab === TopicsTab.myTopics && <TopicsViewTab />}</Box>
          <Box width="100%">{tab === TopicsTab.teamTopics && <TopicsViewTab team />}</Box>
        </Box>
      </Box>
    </BasePageContainer>
  );
};

export default Topics;
